{
	"cardHeader": "Greifen Sie auf Ihre Erklärungen zu",
	"supplierTitle": "Sie sind Lieferant einer evoZero Erklärung?",
	"supplierDescription": "Verwalten Sie die Erklärungen für Ihre evoZero Materialien.",
	"loginButton": "Anmelden"
}
